import React from "react";

export default ({
  id,
  x,
  y,
  oldText,
  newText,
  fillColor,
  fontsize,
  fontfamily,
  filter,
}) => {
  return (
    <text
      id={id}
      name={id}
      x={x}
      y={y}
      style={{fontSize: fontsize, fontFamily: fontfamily, fill: fillColor}}
      filter={filter}
    >{newText}</text>
  );
};
